export default __webpack_public_path__ + "resources/icons/d0-a231.png";